import {reactive} from "vue";

export function useFormFieldTypes() {

    const TEXT = 'text'
    const TEXTAREA = 'textarea'
    const RADIO = 'radio'
    const CHECKBOX = 'checkbox'
    const SELECT = 'select'
    const SELECTMULTIPLE = 'select-multiple'
    const EMAIL = 'email'
    const DATE = 'date'
    const DATETIME = 'datetime'
    const FILE = 'file'
    const URL = 'url'
    const NUMBER = 'number'

    const formFieldTypes = reactive({
        TEXT,
        TEXTAREA,
        RADIO,
        CHECKBOX,
        SELECT,
        SELECTMULTIPLE,
        EMAIL,
        DATE,
        DATETIME,
        FILE,
        URL,
        NUMBER,
    })

    const qvctSurveyTypes = reactive([
        {
            fr: 'Case à cocher',
            en: 'Option box',
            value: RADIO
        },
        {
            fr: 'Paragraphe',
            en: 'Paragraph',
            value: TEXTAREA
        }
    ])


    return { formFieldTypes, qvctSurveyTypes }
}
